import React from 'react'
import { NavLink } from 'react-router-dom'

import { Logo } from '@/assets/images/logo'
import * as manifast from '@/constants/manifast'
import { RoutePath } from '@/routes'

import { Text } from '../common/Text'

const LogoWithName: React.FC = () => {
  return (
    <NavLink to={RoutePath.HOME} className="flex items-center">
      <img src={Logo} className="size-6 xl:size-8" alt="terminus logo" />
      <Text className="font-Silkscreen text-2xl text-white">
        {manifast.Name}
      </Text>
    </NavLink>
  )
}

export default LogoWithName
